import React, { useCallback, useState } from 'react'
import {Main} from './ModalTabs'
import Modal from '../../components/Modal'
import Confirmation from '../../components/Confirmation/Confirmation'


export default function ModalComponent ({data, currentWeek, closeModal, params, onSuccess}) {

  const [mode, setMode] = useState('main')
  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const addMode = !data?.week_id

  const renderTab = () => {
      switch (mode) {
          case 'main': return <Main closeModal={closeModal} data={addMode ? data : currentWeek} addMode={addMode} params={params} onSuccess={onSuccess}/>
          default: return
      }
  }
  
  return (
      <Modal
        open={!!data}
        menuItem={mode}
        setMenuItem={setMode}
        onClose={handleClose}
        closeOnOverlayClick={true}
        closeOnEsc={true}
      >
        {renderTab()}
        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
      </Modal>
  )
}
